// extracted by mini-css-extract-plugin
export default {"root":"Sm7c5TKTTdneCCt7QR8v","placeHolderShimmer":"zlc2PkpwE6Phzem0vwDP"};